import React from 'react';
import ChatBadge from './chatBadge';

import ChatPerson from 'assets/images/notFounds/chatPerson.svg';

interface ChatUserImageProps {
  is_seen: boolean;
}
const ChatUserImage = ({is_seen}: ChatUserImageProps) => {
  return (
    <div className="flex w-[85.75px] h-[85.75px] relative items-center">
      <div className="flex w-[70px] h-[70px]">
        <img
          className="rounded-full"
          src={ChatPerson}
          width={70}
          height={70}
          alt=""
        />
      </div>
      {!is_seen && <ChatBadge color="bg-badge" />}
    </div>
  );
};

export default ChatUserImage;
